var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"single-bar-chart-container"},[_c('div',{staticClass:"number"},[_vm._v(_vm._s(_vm.displayNumberFormattedByRegion(_vm.currentValue)))]),_c('div',{staticClass:"bar-container"},[_c('div',{staticClass:"bar",style:({ width: _vm.barWidth, backgroundColor: _vm.barColor })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }